import { MemberSpotlightArticle as MemberSpotlightArticleType } from '@/components/MemberSpotlightArticle/MemberSpotlightArticle.types'
import { Box, Container, Heading, Stack, Text } from '@chakra-ui/react'
import Image from 'next/image'
import NextLink from 'next/link'

export const MemberSpotlightArticleList = (props: {
  articles?: Array<Partial<MemberSpotlightArticleType>>
  heading?: string
}) => {
  if (!props.articles || !Array.isArray(props.articles)) return null

  return (
    <Box bg='blue.900'>
      <Container maxW='3xl'>
        <Stack py={28} gap={20}>
          {props.articles.map((article, i) =>
            article ? (
              <NextLink href={`/spotlight/${article.slug}`} key={article.slug}>
                <Stack gap={4}>
                  {i === 0 && props.heading ? (
                    <Text
                      color='white'
                      textTransform='uppercase'
                      align='center'>
                      {props.heading}
                    </Text>
                  ) : null}
                  <Heading color='white' size='3xl' textAlign='center'>
                    {article.title}
                  </Heading>
                  <Heading color='white' size='md' textAlign='center'>
                    {article.highlighted_quote}
                  </Heading>
                  <Image
                    src={article.hero_image?.url ?? ''}
                    width={800}
                    height={500}
                    alt=''
                    style={{
                      objectFit: 'cover',
                      objectPosition: 'top',
                      width: '100%',
                    }}
                  />
                </Stack>
              </NextLink>
            ) : null
          )}
        </Stack>
      </Container>
    </Box>
  )
}
